import { render, staticRenderFns } from "./policy-tables-configure-details.vue?vue&type=template&id=14230cb4&scoped=true"
import script from "./policy-tables-configure-details.vue?vue&type=script&lang=js"
export * from "./policy-tables-configure-details.vue?vue&type=script&lang=js"
import style0 from "./policy-tables-configure-details.vue?vue&type=style&index=0&id=14230cb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14230cb4",
  null
  
)

export default component.exports